import { FC } from 'react';
import { AccountProject } from './permissions-table.types';
import {
  Image,
  logos,
  Stack,
  TableCell,
  TextCaption,
} from '@pypestream/design-system';
import { ProductName } from '@pypestream/api-services';
import './permissions-table.scss';

export const getProductIcon = (productName: string) => {
  switch (productName) {
    case ProductName.AgentAssist:
      return logos.contactCenter;
    case ProductName.Analytics:
      return logos.analytics;
    case ProductName.Organization:
      return logos.manager;
    case ProductName.ProStudio:
      return logos.proStudio;
    default:
      return 'Unknown Product';
  }
};

export const ProjectProductCell: FC<{
  projectProductSetting: AccountProject['project']['project_product_settings'][number];
}> = ({ projectProductSetting }) => (
  <TableCell nowrap>
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      gutter="2xsmall"
    >
      <Image
        width="24"
        height="24"
        src={getProductIcon(projectProductSetting.product.name)}
      />
      <TextCaption textAlign="center">
        {projectProductSetting.product?.displayName}
      </TextCaption>
    </Stack>
  </TableCell>
);
